import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import {
  Redirect,
  useHistory,
} from 'react-router-dom/cjs/react-router-dom.min';
import { useDispatch, useSelector } from 'react-redux';
import ReportDetailPage from '../components/ReportDetail/ReportDetailPage';
import getReportDetail from '../actions/api/report/getReportDetail';
import { SELECT_REPORT } from '../actions/actionTypes';
import { ReportStatus } from '../components/ReportEdit/TitleArea';
import getReportPreview from '../actions/api/report/getReportPreview';
import accessible from '../components/Report/functions/authControl';
import { PAGE_PATH } from '../lib/constants';
import { createReportNo } from '../lib/reportTools';

const ReportDetailContainer = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { reportId: strReportId } = useParams();
  const reportId = Number(strReportId);
  dispatch({ type: SELECT_REPORT, payload: { selectedReportId: reportId } });

  const apiToken = useSelector(state => state.main.apiToken);
  const isLogin = useSelector(state => state.main.isLogin);
  const targetGroupId = useSelector(state => state.main.targetGroupId);
  const currentUserInfo = useSelector(state => state.main.userInfo);
  const currentUserRole = useSelector(state => state.main.innerRole);
  const reportDetail = useSelector(state => state.report.reportDetail);
  const groups = useSelector(state => state.group.groups);

  useEffect(() => {
    dispatch(getReportDetail(apiToken, targetGroupId, reportId));
  }, [dispatch, apiToken, targetGroupId, reportId]);

  const editDetail = useSelector(state => state.report.editDetail);

  // 2回目のレンダリングを無視するフラグ
  const [ignore, setIgnore] = useState(false);
  // 報告書プレビューAPIコール
  useEffect(() => {
    if (!reportDetail.id) {
      return;
    }
    // 操作権限取得
    const control = accessible(
      currentUserRole,
      currentUserInfo,
      groups,
      reportDetail,
    );
    if (!control.read) {
      // 閲覧権限が無い場合は一覧を表示する
      history.push(PAGE_PATH.DS_REPORT);
      return;
    }

    if (
      ignore ||
      !editDetail.reportId ||
      (editDetail.status !== ReportStatus.create &&
        editDetail.status !== ReportStatus.published)
    ) {
      // 完了の報告書は報告書詳細情報のurlよりプレビューを表示する
      return;
    }
    // 完了以外の報告書はプレビューを作成して表示する
    const { createDate, name, layoutType } = editDetail;
    const { frames, status } = reportDetail;
    const workFrames = (frames &&
      frames.length > 0 &&
      frames.map(frame => {
        const { workRecord, tags, freeTag, note } = frame ?? {};
        const workRecordId = (workRecord && workRecord.id) ?? null;
        return { note, tags, freeTag, workRecordId };
      })) || [{ workRecordId: null }];

    const requestParams = {
      createDate,
      frames: workFrames,
      name,
      layoutType,
      status,
      createOperatorName: reportDetail?.createdOperatorName,
    };

    requestParams.no = createReportNo(
      reportDetail.groupNo,
      reportDetail.reportNo,
      status,
    );

    dispatch(getReportPreview(apiToken, targetGroupId, requestParams));
    setIgnore(true);
  }, [
    dispatch,
    apiToken,
    targetGroupId,
    ignore,
    editDetail,
    history,
    reportDetail,
    currentUserRole,
    currentUserInfo,
    groups,
  ]);

  if (!isLogin) {
    return <Redirect to="/login" />;
  }

  return <ReportDetailPage />;
};

export default ReportDetailContainer;
